














































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import DecimalNumber from "@/components/shared/DecimalNumber.vue";
import { FuelPriceRow } from "@/model/data.model";
import { PriceListService } from "@/services/PriceListService";
import { cloneDeep } from "lodash";

@Component({
  components: {
    DecimalNumber
  }
})
export default class FuelSurcharge extends Vue {
  macroAreaList: string[] = ["domestic", "europe", "international"];
  macroAreaMap: { name: string; id: number }[] = [
    { name: "domestic", id: 1 },
    { name: "europe", id: 2 },
    { name: "international", id: 3 }
  ];
  fuelPriceRows: FuelPriceRow[] = [];

  get macroareaItem() {
    return (idMacroarea: number, allItems: any[]) => {
      const macroareaItem = cloneDeep(allItems).find(
        (el: any) => el.idMacroarea === idMacroarea
      );
      if (!macroareaItem) return null;
      return macroareaItem;
    };
  }

  created() {
    PriceListService.getFuelPrices().then((res: any) => {
      // Result grouped by service ID ("MBE Standard", "MBE Economy", etc.)
      const resGrouped = Object.values(
        res.reduce((r: any, o: any) => {
          (r[o.idService] = r[o.idService] || []).push(o);
          return r;
        }, [])
      );

      this.fuelPriceRows = resGrouped.map((resItem: any) => {
        const fuelPriceItems = [];
        resItem
          .sort((a: any, b: any) => {
            if (a.idMacroarea > b.idMacroarea) return 1;
            if (a.idMacroarea < b.idMacroarea) return -1;
            return 0;
          })
          .forEach((item: any) => {
            fuelPriceItems.push({
              value: item.value || 0,
              percentage: item.percentage || 0,
              minimum: item.minimum || 0,
              maximum: item.maximum || 0,
              idMacroarea: item.idMacroarea
            });
          });

        return {
          serviceName: resItem[0].serviceName,
          serviceId: resItem[0].idService,
          fuelPriceItems
        };
      });
    });
  }
}
